/**
 * Per-game colours, keyed by the ids stored in a user's `stats` (`cah`,
 * `ana`, …). Names come from `GET /api/games`, which reads the games
 * directory — only the colour lives here, because only the SPA renders it.
 *
 * Every colour except Cards Against Humanity is `hsl(h, 100%, 73%)`. That's
 * #FF75AF expressed in HSL, so the whole set shares one lightness and
 * saturation and only the hue moves; no game reads as louder than another,
 * and hues are spread far enough apart to stay distinguishable at the size of
 * a small circle.
 *
 * Cards Against Humanity is the exception: black with white text, because
 * that's the game's own identity and it would be strange in pastel.
 */
const PASTEL = (hue) => `hsl(${hue}, 100%, 73%)`

/** Dark enough to read on any of the pastels above. */
const ON_PASTEL = '#2b2b2b'

export const gameColors = {
    cah: { background: '#000000', text: '#ffffff' },
    // Family Edition is a sibling of CAH but has to stay distinguishable from
    // it at a glance, so it takes a hue rather than inheriting the black.
    caf: { background: PASTEL(25), text: ON_PASTEL },

    ana: { background: PASTEL(190), text: ON_PASTEL },
    che: { background: PASTEL(280), text: ON_PASTEL },
    c4: { background: PASTEL(50), text: ON_PASTEL },
    oth: { background: PASTEL(150), text: ON_PASTEL },
    pok: { background: PASTEL(0), text: ON_PASTEL },
    sus: { background: PASTEL(220), text: ON_PASTEL },
    // The reference colour, #FF75AF.
    wis: { background: PASTEL(335), text: ON_PASTEL },
}

/** Colours for a game id, falling back to a neutral for anything unknown. */
export function colorsForGame(id) {
    return gameColors[id] || { background: 'hsl(0, 0%, 73%)', text: ON_PASTEL }
}

/**
 * Season pill styling. Pale tint with a darker version of the same hue for
 * the text, plus the icon that names the season without reading it.
 */
export const seasonStyles = {
    Summer: { background: '#EFE3AE', text: '#7A6300', icon: 'sun' },
    Fall: { background: '#F2D6BC', text: '#8A4218', icon: 'leaf' },
    Winter: { background: '#CFE2F2', text: '#1B4F7A', icon: 'snowflake' },
    Spring: { background: '#D3EDC8', text: '#2C6B25', icon: 'seedling' },
}

export function stylesForSeason(season) {
    return seasonStyles[season] || seasonStyles.Summer
}
